define("calendar/models/flatpickr-config", ["exports", "shared/models/flatpickr-config"], function (_exports, _flatpickrConfig) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "default", {
    enumerable: true,
    get: function () {
      return _flatpickrConfig.default;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"shared/models/flatpickr-config"eaimeta@70e063a35619d71f
});